import { baseUrl } from '@cloudsuite/mosaic-shared/scripts/base-url.js'
import { fetcher } from 'components/shared/fetcher.js'
import { GetPrices } from 'components/ordering/async-price/api/get-prices.js'
import { PriceError, PricePerProduct } from 'components/ordering/async-price/api/price-dto.js'

export const executePriceRequest = async (request: GetPrices): Promise<PricePerProduct | PriceError> => {
  const url = new URL(request.path, await baseUrl())
  const response = await fetcher.fetch(url)
  const data: unknown = await parseDataFromResponse(response)

  if (response.ok) return request.parseResponse(data)

  return request.parseError(response.status, data)
}

const parseDataFromResponse = async (response: Response): Promise<unknown> => {
  // https://fetch.spec.whatwg.org/#statuses
  const nullBodyStatuses = [101, 103, 204, 205, 304]

  if (nullBodyStatuses.includes(response.status)) return null

  const text = await response.text()
  if (!text) return null
  return JSON.parse(text)
}
